'use strict';

namespace Core {

    export class ScTextCropper {

        // bound
        height: number;
        moreCaption: string;
        lessCaption: string;
        align: string;

        private cropped: boolean = false;
        private expanded: boolean = false;
        private toggleText: string;

        constructor (
            private $scope: ng.IScope
        ) {}

        init (contentElement: ng.IAugmentedJQuery): void {
            setTimeout(() => {
                let contentHeight: number = contentElement.outerHeight();
                this.cropped = (contentHeight > this.height);
            }, 0);
            this.$scope.$watch('ctrl.expanded', () => {
                this.toggleText = this.expanded ? this.lessCaption: this.moreCaption;
            });
        }

        public toggle() {
            this.expanded = !this.expanded;
        }
    }

    angular
        .module('core')
        .directive('scTextCropper', (): ng.IDirective => {

            return {
                scope: {},
                restrict: 'E',
                replace: true,
                transclude: true,
                controller: ScTextCropper,
                controllerAs: 'ctrl',
                bindToController: {
                    height: '=',
                    moreCaption: '@',
                    lessCaption: '@',
                    align: '@'
                },
                template:  `<div class="sc-c-content-cropper sc-c-content-cropper--{{ctrl.align}}"
                                 ng-class="{'is-cropped': ctrl.cropped}">
                                <div class="sc-c-content-cropper__content" 
                                        ng-class="{'is-cropped': ctrl.cropped}"
                                        ng-style="!ctrl.expanded && {'max-height': ctrl.height + 'px'}"
                                        aria-expanded="ctrl.expanded"
                                        ng-transclude>
                                </div>
                                <div class="sc-c-content-cropper__fader"
                                    ng-if="ctrl.cropped"
                                    ng-attr-hidden="{{ctrl.expanded || undefined}}"></div>
                                <button 
                                    class="sc-c-content-cropper__toggle"
                                    ng-if="ctrl.cropped"
                                    ng-click="ctrl.toggle()">
                                    {{ctrl.toggleText}}
                                </button>
                            </div>`,
                link: (
                    scope: ng.IScope,
                    el: ng.IAugmentedJQuery,
                    attr: ng.IAttributes,
                    controller: ScTextCropper
                ) => {
                    if(!attr.align) {
                        attr.$set('align', 'center');
                    }
                    controller.init(el.find('.sc-c-content-cropper__content'));
                }
            };

        });
}
